<template>
    <section class="about" id="about">
      <div class="about-content">
     <div class="container">
     <div class="moving-object-box hidden">
            <img src="https://i.imgur.com/tJPJJdL.png" class="object" alt="">
    </div>
     <div class="description-box">
              <div class="title-container">
            <h2 class="title">O mnie</h2>
            <h3 class="description">Kim jestem?</h3>
        </div>
      <p class="me" v-if="!mobile">Cześć mam na imię Olivier i jestem młodym Front-End Developerem.</p>
        <p class="passion">Pasjonuję się programowaniem jak i montażem wideo od kilku lat, a pierwsze komercyjne doświadczenie w tworzeniu stron zacząłem zyskiwać w marcu 2022 roku będąc zatrudnionym jako Junior Front End Developer w firmie, w której byłem miesiąc wcześniej na praktykach.</p>
        <p class="school">Aktualnie jestem uczniem 5 klasy technikum na kierunku informatycznym, interesuję się piłką nożną, samochodami, a moim hobby jest trenowanie na siłowni.</p>
     </div>
     </div>
     <div class="shape shape-first object" data-value="-3" > </div>
          <p class="bg-text object" data-value="-1">O MNIE</p>
     </div>
    </section>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      mobile: false,
      windowWidth: null,
    };
  },
  methods: {
    checkScreen() {
      this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 430) {
        this.mobile = true;
        return;
      } else {
        this.mobile = false;
      }
    },
  },
  beforeMount() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
  mounted() {
        const about = document.querySelector(".about");
    about.addEventListener("mousemove", parallax);
    function parallax(e) {
        document.querySelectorAll(".object").forEach(function(move){
            let moving_value = move.getAttribute("data-value");
            let x = (e.clientX * moving_value) /220;
            let y = (e.clientY * moving_value) /220;

            move.style.transform = "translateX(" + x + "px) translateY(" + y + "px)";
      
        });
    }
    } 
}
</script>

<style lang="scss" scoped>
.bg-text {
    z-index: -1;
    position: absolute;
    left: 20%;
    top: 6.5%;
}
// test

.spacer {
    aspect-ratio: 900/600;
    width: 24%;
    opacity: 85%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}

section.about {
  padding: 10rem 0 4rem;
}

.about {
  z-index: 1;
  position: relative;
}

.about-content {
  z-index: 1;
}

.container {
    display: flex;
}

.title-container {
        text-align: left;
        }
        .description {
            margin: 0.2rem 0 0 5rem;
            @media (max-width: 1024px) {
              font-size: 1.25rem;
            }
        }

.moving-object-box {
  text-align: center;
  padding: 0;
}

.description-box {
  width: 60%;
  text-align: justify;
}

.description-box p {
  font-family: 'Poppins', sans-serif;
  letter-spacing: 0.3px;
    font-size: 1.15rem;
}

.description-box .me {
  padding-bottom: 0.5rem;
}

.description-box .passion {
  padding-bottom: 0.5rem;
}

.moving-object-box {
    padding-right: 3rem;
    max-width: 30%;
    margin-top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.moving-object-box img {
   max-height: 70%;
}

.description-box {
  z-index: 999;
}

.shape {
    background-color: #ff4e00;
    background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
    position: absolute;
    z-index: 1;
    margin-top: 2.5rem;
}

.shape-first {
     width: 15.5%;
    height: 22%;
    top: 38.5%;
    right: 10%;
    opacity: 0.9;
     border-radius: 44% 34% 44% 44% / 92% 22% 92% 22%;
}

@media (min-width: 2250px){

     section.about {
      padding: 12rem 0;
}

    .description-box p {
      font-size: 1.4rem;
    }

      .bg-text {
        font-size: 560px;
        left: 14.5%;
        top: -4.5%;
  }


  .moving-object-box img {
    max-height: 80%;
  }

  .shape-first {
    width: 17.5%;
    height: 26%;
  }
}


@media (max-width: 1440px) {
    .bg-text {
        font-size: 380px;
        overflow: hidden;
        width: 150%;
        top: 12%;
        left: -25%;
  }
}


@media (max-width: 1024px) {

    .bg-text {
        font-size: 330px;
  }
  

  section.about {
    overflow: hidden;
    padding: 4rem 0;
  }

    .container {
      flex-direction: column;
      align-items: center;
    }

    .moving-object-box {
      display: none;
    }

.shape-first {
    display: none;
}


}

@media (max-width: 768px) {

  section.about {
  padding: 1.5rem 0 3rem;
}

    .bg-text {
        font-size: 380px;
        left: -75%;
        top: 0%;
        width: 200%;
  }
  
    .description-box {
      width: 75%;
    }

    .description-box p {
      font-size: 1rem;
    }

    .description-box .me {
      font-size: 1.1rem;
      text-align: initial;
    }

}


@media (max-width: 425px) {
  .bg-text {
        font-size: 330px;
        width: 150%;
        top: 14%;
        left: -25%;
  }
}

</style>